import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_16_9675)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 5H15V15H5V5ZM6 6V14H14V6H6Z"
        fill="#4F4F4F"
      />
    </g>
    <defs>
      <clipPath id="clip0_16_9675">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SVGComponent;
